module.exports = __webpack_public_path__ + "img/choose-up-12_2 virtual_text.548e662b.png";